import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';
import { handleApiError } from './axiosConfig';

// Types
export interface ContactFormData {
  name: string;
  email: string;
  type: string;
  company?: string;
  message?: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
}

// Contact form submission hook
export const useSubmitContactForm = () => {
  return useMutation({
    mutationFn: async (formData: ContactFormData): Promise<ContactResponse> => {
      try {
        return await apiClient.post<ContactResponse>('/api/contact', formData);
      } catch (error) {
        const errorMessage = handleApiError(error);
        console.error('Failed to submit contact form:', errorMessage);
        throw new Error(errorMessage);
      }
    },
    onSuccess: (data) => {
      console.log('Contact form submitted successfully:', data);
    },
    onError: (error) => {
      console.error('Contact form submission failed:', error);
    },
  });
};